export function removeEscapedText(text: string) {
  // Replace common escape sequences with their intended meaning
  const processedText = text.replace(/\\n/g, '\n')
                          .replace(/\\t/g, '\t')
                          .replace(/\\r/g, '\r')
                          .replace(/\\f/g, '\f')
                          .replace(/\\b/g, '\b');
  return processedText;
}